<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<div class="searchblock">
					<search></search>
				</div>
				 <!-- 列表 -->
				 <div class="directoryContent">
					 <div class="item" v-for="(item, index) in directoryContent" :key="index">
						 <h3 class="font28 t-center">{{item.name}}</h3>
						 <template v-if="item.children.length>0">
							<div class="dcBox bd10" v-for="(item2, index2) in item.children" :key="index2">
							<div class="boxtit d-flex a-center">
								<h4 class="bt font24 f-light">{{item2.name}}</h4>
								<div class="divder"></div>
								<div class="icon"><i></i></div>
							</div>
							<div class="dcm">
								<div class="boxbd d-flex">
									<h4 class="bt font24 f-light"></h4>
									<div class="subs tg1">
										<div class="subi d-flex a-center j-sb" v-for="(item3, index3) in item2.children" :key="index3">
											<span>{{item3.name}}</span>
											<i class="el-icon-arrow-right"></i>
										</div>
									</div>
									<div class="subs tg2">
										<div class="subsi" v-for="(item3, index3) in item2.children">
											<div class="subi d-flex a-center j-sb" v-for="(item4, index4) in item3.children" :key="index4">
												<span>{{item4.name}}</span>
												<i class="el-icon-arrow-right"></i>
											</div>
										</div>
									</div>
									<div class="lis tg3">
										<div class="li1" v-if="item2.children==0"></div>
										<div class="li1" v-for="(i, index3) in item2.children">
											<div class="li2" v-if="i.children==0"></div>
											<div class="li2" v-for="(j, index4) in i.children">
												<div class="li3">
													<dl class="d-flex f-wrap">
														<template v-for="k in j.product">
															<dd class="disc line-sm font-light" v-if="k.isIpProject" @click="goToPage('/ipProduct?id='+k.id)"><a href="javascript:;" class="link">{{k.name}}</a></dd>
															<dd class="disc line-sm font-light" v-else @click="goToPage('/productDirectory?productId='+k.id)"><a href="javascript:;" class="link">{{k.productName}}</a></dd>
														</template>
													</dl>
												</div>
											</div>
											<dl class="d-flex f-wrap">
												<template v-for="(l, index4) in i.product">
													<dd class="disc line-sm font-light" v-if="l.isIpProject" @click="goToPage('/ipProduct?id='+l.id)"><a href="javascript:;" class="link">{{l.name}}</a></dd>
													<dd class="disc line-sm font-light" v-else @click="goToPage('/productDirectory?productId='+l.id)"><a href="javascript:;" class="link">{{l.productName}}</a></dd>
												</template>
											</dl>
										</div>
										<dl class="d-flex f-wrap">
											<template v-for="(l, index4) in item2.product">
												<dd class="disc line-sm font-light" v-if="l.isIpProject" @click="goToPage('/ipProduct?id='+l.id)"><a href="javascript:;" class="link">{{l.name}}</a></dd>
												<dd class="disc line-sm font-light" v-else @click="goToPage('/productDirectory?productId='+l.id)"><a href="javascript:;" class="link">{{l.productName}}</a></dd>
											</template>
										</dl>
									</div>
								</div>
							</div>
						 </div>
						 </template>
						 <template v-else>
							<div class="dcBox bd10">
								<div class="boxbd d-flex">
									<div class="lis tg3">
										<dl class="d-flex lis-5 f-wrap">
											<template v-for="(l, index4) in item.product">
												<dd class="disc line-sm font-light" v-if="l.isIpProject" @click="goToPage('/ipProduct?id='+l.id)"><a href="javascript:;" class="link">{{l.name}}</a></dd>
												<dd class="disc line-sm font-light" v-else @click="goToPage('/productDirectory?productId='+l.id)"><a href="javascript:;" class="link">{{l.productName}}</a></dd>
											</template>
										</dl>
									</div>
								</div>
						 </div>
						 </template>
					 </div>
				 </div>
				 
			</div>
		</div>
  </div>
</template>

<script>

export default {
  name: 'ProductDirectory',
  components: {
    
  },
  data() {
    return {
		// 目录
		directoryContent: [],
		ipproduct:[]
	}
  },
  
  created() {
	  // 获取产品目录
	  this.getDirectoryContent();
	  //this.getProductVoList();
  },
  
  methods: {
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  		  	path,
  			query
  		  })
  	  },
	  
	  // 获取产品目录
	  getDirectoryContent() {
		  this.$axios.get(`product/catalogue`)
		  .then(res => {
			  let data = res.data;
			  this.directoryContent = data;
			  this.$nextTick(function(){
				$('.boxbd').each(function(){
					var that=$(this);
					$(this).find('.tg2 .subi').mouseover(function(){
						$(this).addClass('cur').siblings().removeClass('cur');
						var index=$(this).index()
						that.find('.li1').each(function(){
							$(this).find('.li2').eq(index).show().siblings().hide();
						})
					});
					$(this).find('.tg1 .subi').mouseover(function(){
						$(this).addClass('cur').siblings().removeClass('cur');
						that.find('.tg2 .subsi').eq($(this).index()).show().siblings().hide();
						that.find('.li1').eq($(this).index()).show().siblings().hide();
					});
					
					$(this).find('.tg1 .subi:first').mouseover();
					$(this).find('.tg2 .subi:first').mouseover();
				});
				$('.dcBox .boxtit .icon').click(function(){
					$(this).toggleClass('act');
					$(this).parents('.dcBox').find('.dcm').slideToggle();
				})
			})
		  })
		  .catch(err=>{})
	  },
	  getProductVoList() {
		  this.$axios.post('member/ipProductPage')
		  .then(res => {
			  this.ipproduct = res.data.list;
		  })
		  .catch(err => {})
	  }
  },
  mounted:function(){
	
  }
}
</script>

<style lang="less" scoped>
.searchblock{
	margin: 0.5rem 0;
}
	.directoryContent{
		.item{
			&:nth-of-type(1) h3{
				color: #fff;
			}
			&:not(:last-child) {
				margin-bottom: .8rem;
			}
			.dcList{
				margin-top: .4rem;
				ul{
					margin: 0 -.1rem;
					margin-top: -.2rem;
					li{
						width: 33.33%;
						padding: 0 .1rem;
						margin-top: .2rem;
						dl{
							padding: .3rem;
							height: 100%;
							dt{
								width: 100%;
								margin-bottom: .1rem;
							}
							dd{
								width: 50%;
								padding-right: .2rem;
								margin-top: .2rem;
							}
						}
					}
				}
			}
			h3{
				margin-bottom:.4rem;
			}
		}
		@media (max-width: 1200px) {
			.item{
				.dcList{
					ul{
						li{
							width: 50%;
							
						}
					}
				}
			}
			
		}
		@media (max-width: 640px) {
			.item{
				.dcList{
					ul{
						li{
							width: 100%;
							
						}
					}
				}
			}
		}
	}
	.dcBox{
		padding: 30px;
		padding-bottom: 0;
		margin-bottom: 30px;
		.boxtit{
			align-items: center;
			justify-content: space-between;
			padding-bottom: 20px;
			.divder{
				height: 1px;
				flex: 1 1 auto;
				background: #f3f3f3;
				margin: 0 30px;
			}
			.icon{
				flex: 0 0 auto;
				padding: 15px;
				position: relative;
				cursor:pointer;
				&:before,&:after{
					content: "";
					position: absolute;
					width: 14px;
					height: 2px;
					background: #666;
					left:50%;
					top:50%;
					margin-left:-7px;
				}
				&:after{
					transform:rotate(90deg);
					transition:.3s;
				}
				&.act:after{
					transform: rotate(0deg);
				}
			}
		}
		.bt{
			flex:0 0 auto;
			width:7em;
			font-weight:normal;
		}
		.dcm{
			display: none;
		}
		.boxbd{
			align-items:stretch;
			padding-left:30px;
			padding-right:40px;
			padding-bottom: 40px;
			.subs{
				flex:0 1 auto;
				.subi{
					cursor:pointer;
					padding:20px 0;
					border-bottom:1px solid #f3f3f3;
					font-size:18px;
					width:360px;
					margin-right:60px;
					line-height:1.5;
					&.cur{
						color:#2657db;
					}
				}
				
			}
			.lis{
				flex:1 1 auto;
				max-height: 352px;
				overflow: auto;
				&::-webkit-scrollbar,.selects::-webkit-scrollbar{width:3px;height:3px;}
				&::-webkit-scrollbar-thumb{border-radius:2px;-webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.1);background:#2657db;}
				&::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.2);border-radius:10px;background:#eeeef0;}
				dd{
					margin:10px 0;
					flex:0 1 220px;
					padding-right:30px;
				}
				.lis-5{
					dd{flex: 0 1 20%;}
				}
			}
			@media(max-width:1200px){
				padding-left:0;
				padding-right:0;
				.bt{
					display:none;
				}
				.subs{
					.subi{
						width:250px;
						margin-right:30px;
						padding:15px 0;
						font-size:16px;
					}
				}
			}
		}
		@media(max-width:768px){
			padding:20px 20px 0;
			margin-bottom:15px;
			.bt{
				width:auto;
			}
			.subs{
				width:50%;
				.subi{
					width:95% !important;
					margin-right:5% !important;
					font-size:14px !important;
				}
			}
			.boxbd{
				flex-wrap:wrap;
				.lis{
					width:100%;
				}
			}
		}
	}
</style>
